module.exports = require("plugin-assets/shared/widget/components/widget-axis");